/**
 * DeleteModal Component
 * Reusable delete confirmation modal
 */

import React from "react";
import { Modal, Button, CircularProgress } from "@mui/material";
import "./DeleteModal.css";

interface DeleteModalProps {
  open: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
  deleteButtonStyle: any;
  cancelButtonStyle: any;
  message?: string;
  title?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  open,
  isDeleting,
  onClose,
  onDelete,
  deleteButtonStyle,
  cancelButtonStyle,
  message = "Are you sure you want to delete this item?",
  title = "DELETE CONFIRMATION",
}) => {
  return (
    <Modal
      open={open}
      onClose={() => !isDeleting && onClose()}
      aria-labelledby="delete-confirmation-modal-title"
      aria-describedby="delete-confirmation-modal-description"
    >
      <div className="delete-modal-popup">
        <h6 className="delete-modal-h6">{title}</h6>
        <hr className="mb-0" />
        <div className="delete-modal-body">
          <div style={{ marginBottom: "20px" }}>
            <div className="delete-modal-text">
              {isDeleting ? "Deleting, please wait..." : message}
            </div>
            {isDeleting && (
              <div className="delete-modal-loader">
                <CircularProgress size={24} style={{ color: "#2aa7e0" }} />
              </div>
            )}
          </div>
        </div>
        <div className="delete-modal-buttons">
          <Button
            disableElevation
            variant="contained"
            style={deleteButtonStyle}
            onClick={onDelete}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
          <Button
            disableElevation
            variant="contained"
            style={cancelButtonStyle}
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
